class ScrollTo
{
    static init() {
        Array.from(document.querySelectorAll('[data-action="scroll-to"]')).forEach((element) => {
            element.addEventListener('click', (event) => {
                event.preventDefault();

                let relatedBlock = document.querySelector(element.getAttribute('data-related'));

                if (relatedBlock) {
                    window.scrollTo({
                        top: relatedBlock.offsetTop,
                        behavior: 'smooth',
                    });
                }
            });
        });
    }
}

export {ScrollTo};
